import { configureStore } from "@reduxjs/toolkit";
import { loadState, saveState } from "./localStorage";
import authReducer from "./reducers/auth";

const persistedState = loadState();

const store = configureStore({
	reducer: { auth: authReducer },
	preloadedState: persistedState,
});

store.subscribe(() => {
	saveState(store.getState());
});

export default store;
